module.exports = __webpack_public_path__ + "img/title1.5104c215.png";